import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { removeEmptyProp } from '@/utils'
import ActionTypes from '../constants'
import { UserResponse, DeleteUserPayload, UserState } from '../models'

import { USER } from './api.routes'
import { getAllUsersThunk } from './get-all.thunk'

const apiService: RestApiService = Container.get(RestApiService)

export const deleteUserThunk = createAsyncThunk(
  ActionTypes.DELETE_USER,
  async (payload: DeleteUserPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'DELETE',
        endpoint: USER.DELETE,
        body: payload,
      }

      const { auth, user } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: UserResponse = await apiService.deleteAuthData(
        auth.token || '',
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('user')} ${payload.id}`,
        what: i18n.t('labels.deleted'),
      })

      if (response.status === 200 || response.status === undefined) {
        thunkAPI.dispatch(getAllUsersThunk(removeEmptyProp(user.filters)))
      } else {
        message = i18n.t('messages.errorOccurred')
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant:
            response.status === 200 || response.status === undefined
              ? 'success'
              : 'error',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const deleteUserExtraReducer = (
  builder: ActionReducerMapBuilder<UserState>,
) => {
  builder.addCase(deleteUserThunk.fulfilled, (state, { payload }) => {
    state.wasDeleted = true
  })
}

export default deleteUserExtraReducer
